import React, { Suspense, useState } from "react";
import { Button } from "antd";

const ViewItenary = React.lazy(() => import("./ViewItenary"));

const Itenary = ({
  values,
  isUpdate,
  isView,
  setItenary,
  setOpenItenary,
  indexValue,
  setIndex,
  handleDelete,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="my-2">
      <div className="w-full py-2 px-4 bg-gray-200 flex items-center justify-between">
        <p className="text-sm font-Montserrat font-bold text-gray-600">
          {values?.title}
        </p>
      </div>

      <div className="w-full grid grid-cols-12 border border-gray-200 rounded-bl-md rounded-br-md">
        <div className="border-r border-gray-200  flex flex-col  items-center py-2  col-span-1">
          <p className=" font-Nunito text-sm font-medium text-gray-600">Day</p>
          <p className=" font-Nunito text-sm font-bold text-gray-700 py-2">
            {values?.day}
          </p>
        </div>
        <div className=" border-r border-gray-200  flex flex-col px-4 py-2 col-span-6">
          <p className=" font-Nunito text-sm font-medium text-gray-600">
            Description
          </p>
          <p className=" font-Nunito text-sm font-bold text-gray-700 py-2 max-w-xs truncate">
            {values?.description}
          </p>
        </div>
        <div className="  flex  flex-col px-4 py-2 col-span-3">
          <p className=" font-Nunito text-sm font-medium text-gray-600 pb-2">
            Action
          </p>
          <div className=" flex items-center gap-2">
            <Button type="primary" onClick={() => setIsVisible(true)}>
              View
            </Button>
            {!isView && (
              <>
                <Button
                  type="outlined"
                  onClick={() => {
                    setItenary(values);
                    setOpenItenary(true);
                    setIndex(indexValue);
                  }}
                >
                  Edit
                </Button>
                <Button type="danger" onClick={handleDelete}>
                  Delete
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
      <Suspense fallback={<div>loading...</div>}>
        <ViewItenary
          isVisible={isVisible}
          handleCancel={() => setIsVisible(false)}
          values={values}
        />
      </Suspense>
    </div>
  );
};

export default Itenary;
